import React from 'react'
import BreadCrumb from '../components/BreadCrumb';
import Meta from '../components/Meta';
import { Link } from 'react-router-dom';
import Container from '../components/Container';
import Custominput from '../components/Custominput';

const Resetpassword = () => {
  return (
    <>
        <Meta title={'Reset Password'} />
        <BreadCrumb title='Reset Password'/>
        <Container class1='login-wrapper py-5 home-wrapper-2'>
            <div className='row'>
                <div className='col-12'>
                    <div className='auth-card'>
                        <h3 className='text-center mb-3'>Reset Password</h3>
                        <form action='' className='mt-3 d-flex flex-column gap-15'>
                            <Custominput type='password' name='password' placeholder='Password' />
                            <Custominput className='mt-3' type='confirm-password' name='confirm password' placeholder='Confirm password' />
                            <div>
                                <div className='d-flex justify-content-center gap-15 align-items-center'>
                                    <button className='button border-0' type='submit'>Submit</button>
                                    <Link to='/login' className='button signup'>Login</Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Container>
    </>
  )
}

export default Resetpassword